<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Journal Entries Summary</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row dense>
          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" md="3">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.StartDate"
                  label="From"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <!-- datepicker 2 -->
          <v-col cols="12" xs="12" md="3">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  dense
                  outlined
                  single-line
                  v-model="record.EndDate"
                  label="To"
                  prepend-icon="mdi-calendar-month"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete
              autocomplete="off"
              dense
              outlined
              v-model="record.AccountId"
              :items="accounts"
              label="Account"
              item-text="Name"
              item-value="id"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete
               autocomplete="off"
              dense
              outlined
              v-model="record.CustomerId"
              :items="customers"
              label="Customer"
              item-text="Name"
              item-value="id"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete
               autocomplete="off"
              dense
              outlined
              v-model="record.SupplierId"
              :items="suppliers"
              label="Supplier"
              item-text="Name"
              item-value="id"
            ></v-autocomplete>
          </v-col>


          <v-col cols="12" xs="12" md="9">
            <v-btn class="right" color="primary" :loading="loader" @click="getReport">Generte Report</v-btn>

            <v-btn icon class="float-right">
              <download-excel :data="journalData" :fields="fields" name="Customer Summary">
                <v-icon color="green">mdi-file-excel</v-icon>
              </download-excel>
            </v-btn>

            <v-btn icon class="float-right">
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field label="Search" v-model="search"></v-text-field>
            <v-data-table
              :items-per-page="2000"
              :mobile-breakpoint="0"
              :headers="headers"
              :items="journalData"
              :search="search"
            ></v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      menu1: false,
      menu2: false,
      search: null,
      record: {},
      loader: false,
      customers: [],
      suppliers: [],
      accounts: [],
      journalData: [],
      headers: [
        { text: "Account Name", value: "oact.Name" },
        { text: "Bp / Name", value: "ocrd.Name" },
        { text: "Debit", value: "Debit" },
        { text: "Credit", value: "Credit" },
        { text: "Remarks", value: "Remarks" },
        { text: "Date", value: "DocDate" },
      ],
      fields: {
        Account: "account.Name",
        Debit: "Debit",
        Credit: "Credit",
        Remarks: "Remarks",
        Date: "DocDate",
      },
    };
  },
  methods: {
    getReport() {
      const data = this.record;
      const url = "/journal/summary";
      const self = this;
      // this.loader = true;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.journalData = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("loader", false);
          }
          self.loader = false;
        })
        .catch((err) => {
          self.$store.commit("loader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      self.$store.commit("loader", false);
      this.$store
        .dispatch("get", `/accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
      getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created () {
    this.getAccounts();
    this.getCustomers();
    this.getSuppliers();
  },
};
</script>

<style lang="scss" scoped>
</style>